export default __webpack_public_path__ + "static/4-085aba9936afac897fcadc4f19a5795d.jpg";